import { useFieldHelper, FieldProps } from 'framework/ui/field';
import { EditableBadge } from 'framework/ui/ui-builder';
import { RECRUITING_VACANCY_GROUP_UPDATE } from 'domain/shared/newVacancy';
import { useAuthorization } from 'framework/authorization';
import useRecruitingBoardService from '../../useRecruitingBoardService';
import { VacancyItem, VacancyPriority } from '../../types';
import { VacancyPriorityShortLabels } from '../../constants';
import { ChipOwnProps } from '@mui/material';

const RECRUITING_CONTEXT = 'Recruiting';

const VacancyPriorityColor: Record<string, ChipOwnProps['color']> = {
  [VacancyPriority.HIGH]: 'error',
  [VacancyPriority.MEDIUM]: 'warning',
  [VacancyPriority.LOW]: 'success',
};

interface PriorityBadgeProps extends FieldProps {
  prioritySource: string;
  idSource: string;
  onChange?: (vacancy: VacancyItem) => void;
}

const PriorityBadge = ({ idSource, prioritySource, onChange = () => {} }: PriorityBadgeProps) => {
  const { getValue: getPriority } = useFieldHelper({ source: prioritySource });
  const { getValue: getId } = useFieldHelper({ source: idSource });
  const { isGranted } = useAuthorization();

  const priority = getPriority() as VacancyPriority;
  const { updatePriority } = useRecruitingBoardService();

  const handleChange = async (newPriority: string) => {
    const updatedPriority = await updatePriority(getId(), newPriority);
    onChange(updatedPriority);
  };

  return (
    <EditableBadge
      color={VacancyPriorityColor[priority]}
      values={Object.values(VacancyPriority).map(value => ({
        value,
      }))}
      onChange={handleChange}
      canUpdate={isGranted(RECRUITING_VACANCY_GROUP_UPDATE, RECRUITING_CONTEXT)}
    >
      {VacancyPriorityShortLabels[priority]}
    </EditableBadge>
  );
};

export default PriorityBadge;
